import React from "react"
import Mistake from "../components/mistake"

// must be 3 items
export default {
  badEnglish: "I want speak English good.",
  Correction: () => (
    <span>
      I want <Mistake>speak</Mistake> English <Mistake>good</Mistake>.
    </span>
  ),
  improvements: [
    "I want to speak english.",
    "I want to speak english well.",
    "I want to speak English well.",
  ],
}
